const userLabel = require("../label/user");

const note_user_subscription_accept = {
  key: "note_user_subscription_accept",
  count_alias: "count_user_subscription_accepts_new",
  label_activity: "accepted subscription requests",
  label_data: "new subscription accept",
  label_detail: "A user accepts a subscription I've requested.",
  label_title: () => "Subscription Accepted",
  label_zero_state:
    "When a user accepts a subscription you've requested, we'll notify you here.",
  makeNote: (user) => userLabel(user) + " accepted your subscription request.",
  makeLink: ({ username }) => "/user/" + username,
  table: "subscription",
  leftJoins: ["subscription_user"],
  keys: [
    "subscription.id AS id",
    "subscription.updated_at AS noted_at",
    "subscription_user.username AS username",
    "subscription_user.display_name AS display_name",
  ],
  wheres: [
    "subscription.subscriber_id = ?",
    "subscription.code = TRUE",
    "subscription_user.is_private = TRUE",
  ],
  where_since: {
    index: 1,
    sql: "subscription.updated_at >= ?",
    key: "note_last",
  },
  escapeValues: (user) => [user.id],
};

module.exports = note_user_subscription_accept;
